import * as React from "react";
import { Badge } from "components/bootstrap";
import { OverlayTrigger } from "components/common";
const STATUS_PRESENTATION = {
  ready: { label: "Ready", icon: "check_circle", color: "success" },
  not_ready: { label: "Not Ready", icon: "cancel", color: "danger" },
  missing_credentials: { label: "Missing Credentials", icon: "key", color: "warning" },
  invalid_credentials: { label: "Invalid Credentials", icon: "key_off", color: "warning" },
  unknown: { label: "Checking\u2026", icon: "hourglass_top", color: "primary" }
};
const readProvenLine = (readProven) => {
  if (readProven === true) {
    return "Read permission proven by a successful object read.";
  }
  if (readProven === false) {
    return "Read permission not proven yet \u2014 the repository prefix is still empty; the check upgrades automatically after the first snapshot lands.";
  }
  return null;
};
const StatusCell = ({ repository }) => {
  var _a;
  const presentation = (_a = STATUS_PRESENTATION[repository.status]) != null ? _a : STATUS_PRESENTATION.unknown;
  const { details, credential_details } = repository;
  const readProven = readProvenLine(repository.read_proven);
  const hasDetails = !!(details || credential_details || readProven);
  const statusLabel = /* @__PURE__ */ React.createElement(
    Badge,
    {
      color: presentation.color,
      variant: "light",
      leftIcon: presentation.icon,
      title: presentation.label,
      "aria-label": presentation.label
    },
    presentation.label
  );
  if (!hasDetails) {
    return statusLabel;
  }
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: ["hover", "focus"],
      placement: "bottom",
      title: "Status details",
      width: 350,
      overlay: /* @__PURE__ */ React.createElement(React.Fragment, null, details && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "Verification:"), " ", details), credential_details && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, "Credentials:"), " ", credential_details), readProven && /* @__PURE__ */ React.createElement("p", null, readProven))
    },
    statusLabel
  );
};
export default StatusCell;
